<section class="coverage-page">
    <section class="coverage-section">
      <div class="container-flex">
        <div class="container-flex-row">
          <div class="col-md-12 col-12">
            <h1 class="header" *ngIf="!coverageChecked">Coast to Coast Coverage</h1>
            <h1 class="header" *ngIf="!!coverageChecked">Here’s your coverage on Americas largest and most trusted 5G
              wireless networks</h1>
            <p class="description" *ngIf="!coverageChecked">FreeUp is powered by the nation's largest and most trusted
              wireless network. In fact, Global Wireless Solutions Best Network OneScore
              crowns our network partner the "Best US network in largest ever mobile performance evaluation".
            </p>
            <p class="description" *ngIf="!!coverageChecked">Select Check your phone to find out if your phone is
              compatible with the best coverage in your area.
              <span>Network coverage and performance vary by phone.</span>
            </p>
            <div class="actions" *ngIf="!!coverageChecked">
              <button class="button primary" (click)="goTocheckCompatibility()">Check your phone</button>
              <button class="button secondary" (click)="goToplans()">Shop plans</button>
            </div>
          </div>
          <div class="col-12">
            <iframe id="ATT_coverage" allowtransparency="true" src="https://www.att.com/maps/reseller.html"
            frameBorder="0" allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </section>
    <section class="coverage-section padding-top-20">
      <div class="container-flex lte-section">
        <div class="container-flex-row">
          <p class="description left">
            We've partnered with the country's top carrier covering more than 99% of Americans. That's
            over 320 million people with its voice and data service, and over 308 million people covered by its 4G LTE
            network.
          </p>
          <div class="lte paragraph-section">
            <h2 class="lte-title">What is LTE cell phone coverage?</h2>
            <p class="lte-description">
              LTE stands for Long Term Evolution and is short for a very technical process for high-speed data for phones
              and other mobile devices.
              We got you covered with a reliable 5G phone network. Compatible device required.5G not available
              everywhere.
            </p>
          </div>
        </div>
        <div class="container-flex-row disclaimer-container">
          <div class="col-md-12 col-12 paragraph-section">
            <p class="disclaimer">
              Important Information About This Coverage Map
            </p>
            <p class="disclaimer">
              These maps provide a predicted high-level approximation of wireless coverage. There are gaps in coverage
              that are not shown by this high-level approximation. Actual coverage may differ from map graphics and may be
              affected by terrain, weather, network changes, foliage, buildings, construction, signal strength, high-usage
              periods, customer equipment, and other factors. We cannot guarantee coverage. Our coverage maps are not
              intended to show actual customer performance on the network or future network needs or build requirements
              inside or outside of existing coverage areas. Coverage maps may include areas served by unaffiliated
              carriers. Arrangements with these carriers may change from time to time, and coverage is subject to change
              without notice. Charges will be based on the location of the site receiving and transmitting the call, not
              the subscriber’s location. Your phone’s display does not indicate the rate you will be charged.
            </p>
            <p class="disclaimer">
              These maps are subject to the Microsoft® Service Agreement and for informational purposes only. No guarantee
              is made regarding their completeness or accuracy. Construction projects, traffic, or other events may cause
              actual conditions to differ from these results. Map and traffic data 2013 NAVTEQ®
            </p>
            <p class="disclaimer primary-color">
              This map shows an approximation of wireless data coverage in the United States, Puerto Rico, and the U.S.
              Virgin Islands.
            </p>
          </div>
        </div>
      </div>
    </section>
  </section>